import { render, staticRenderFns } from "./DemonstracaoResultadoPeriodo.vue?vue&type=template&id=6968204c&scoped=true"
import script from "./DemonstracaoResultadoPeriodo.vue?vue&type=script&lang=js"
export * from "./DemonstracaoResultadoPeriodo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6968204c",
  null
  
)

export default component.exports